/* eslint-disable @typescript-eslint/naming-convention */
import { DisconnectClutchInputInDB } from 'src/api';

export const clutchComponent: DisconnectClutchInputInDB = {
  component_type: 'ClutchInput',
};
